import React, { useContext, useState } from "react";
import { graphql, Link } from "gatsby";
import parse from "html-react-parser";
import { navigate } from "@reach/router";
import Seo from "../components/Seo";
import StoreContext from "../context/store";
import { Media } from "../components/Media";
import CheckoutButtons from "../components/productPage/CheckoutButtons";
import Gallery from "../components/productPage/Gallery";
import StarRating from "../components/productPage/StarRating";
import ProductReviews from "../components/productPage/ProductReviews";
import FreeShipping from "../images/svgs/delivery-truck-icon.svg";
import MoneyBack from "../images/svgs/money-icon.svg";
import Modal from "../components/Modal";
import AussieOwned from "../components/seals/AustralianOwned";
import Vegan from "../components/seals/VeganFriendly";
import Vegetarian from "../components/seals/VegetarianFriendly";
import SugarFree from "../components/seals/SugarFree";
import GlutenFree from "../components/seals/GlutenFree";
import OneADay from "../components/seals/OneADay";
import SmallBottle from "../images/svgs/small-bottle-icon.svg";
import LargeBottle from "../images/svgs/large-bottle-icon.svg";
// import RecurringIcon from "../images/svgs/recurring-icon.svg";

import "../styles/product.css";

const ProductTemplate = ({ data }) => {
  const context = useContext(StoreContext);
  const { checkout } = context.store;
  const product = data.shopifyProduct;
  const reviews = data.yotpoProduct;

  console.log(reviews);

  const mainColor = () => {
    switch (product.handle) {
      case "b-active":
      case "love-your-muscles":
        return "#2AAE76";
      case "adreno-ignite":
      case "chill-out":
        return "#FFBA09";
      case "you-beauty":
        return "#E5154A";
      case "joint-pain-sucks":
        return "#FF5E0A";
      default:
        return "#E5154A";
    }
  };
  const [order, setOrder] = useState({
    quantity: 1,
    hasVariant: product.variants.length > 1,
    currentVariant: 0,
    inStock: true,
    recurring: false,
    recurringInt: 0,
    veganFriendly: product.handle === "adreno-ignite" ? false : true,
    vegetarian: product.handle === "adreno-ignite" ? true : false,
    sugarFree:
      product.handle === "adreno-ignite" || product.handle === "you-beauty"
        ? false
        : true,
    oneADay:
      product.handle === "you-beauty" || product.handle === "b-active"
        ? true
        : false,
    starRating: reviews ? reviews.bottomline.averageScore : 0,
    reviewCount: reviews ? reviews.bottomline.totalReview : 0,
  });

  const [modal, setModal] = useState(false);

  const showModal = () => {
    setModal(true);
  };

  const productVariant =
    context.store.client.product.helpers.variantForOptions(
      product,
      product.variants[order.currentVariant]
    ) || product.variants[order.currentVariant];

  const handleVariantChange = (e) => {
    setOrder((prevState) => ({
      ...prevState,
      currentVariant: parseInt(e.target.value),
    }));
  };

  // const handleRecurringChange = (e) => {
  //   setOrder((prevState) => ({
  //     ...prevState,
  //     recurring: e.target.value == "true",
  //   }));
  // };

  const setRecurringSchedule = (e) => {
    setOrder((prevState) => ({
      ...prevState,
      recurringInt: parseInt(e.target.value),
    }));
  };

  return (
    <>
      {/* Modal for Money Back Guarantee */}
      <Modal visible={modal} toggle={setModal}>
        <h2 className="text-30 md:text-35 text-center my-4 text-gray-mid">
          Money Back Guarantee
        </h2>
        <p className="mb-4 leading-relaxed">
          We strongly believe in our products and want every customer to leave
          satisfied.
          <br />
          <strong className="bg-yellow-light text-gray-light">
            All of our products are backed by a 60 day money back guarantee.
          </strong>{" "}
          If for any reason you aren't satisfied with your product, contact us
          and we'll provide a refund for the purchase price of the product(s),
          excluding any shipping charges.
        </p>
        <p>
          For full terms and conditions,{" "}
          <Link to="/money-back-guarantee" className="text-green underline">
            click here.
          </Link>
        </p>
      </Modal>

      <Seo title={product.title} />
      <div className="bg-gradient-to-b from-white to-gray-lightest">
        <div className="max-w-screen-lg md:grid md:grid-cols-2 md:mx-auto md:grid-flow-row md:auto-rows-min">
          <Media greaterThanOrEqual="md">
            <div className="m-6 mt-12">
              <Gallery product={product} />
            </div>
          </Media>
          <div className="md:row-span-3">
            <div className="bg-white border-gray-border border-b p-8 md:border-b-0 md:shadow-md md:ml-4">
              <h1 className="text-gray text-35 md:text-50">{product.title}</h1>
              <Media lessThan="md">
                <Gallery product={product} />
              </Media>
              <div className="flex items-center justify-between">
                <h3 className="text-red text-35 my-4">
                  {`$${product.variants[order.currentVariant].price}`}{" "}
                  {parseInt(
                    product.variants[order.currentVariant].compareAtPrice
                  ) >
                    parseInt(product.variants[order.currentVariant].price) && (
                    <span className="text-30 text-gray-lighter line-through">
                      ${product.variants[order.currentVariant].compareAtPrice}
                    </span>
                  )}
                </h3>
                <StarRating
                  rating={order.starRating}
                  text={`${order.reviewCount} reviews`}
                />
              </div>
              <div className="flex justify-center pb-5 border-b border-gray-border">
                <AussieOwned fill={mainColor()} light={true} />
                {order.veganFriendly && (
                  <Vegan fill={mainColor()} light={true} />
                )}
                {order.vegetarian && (
                  <Vegetarian fill={mainColor()} light={true} />
                )}
                {order.sugarFree && (
                  <SugarFree fill={mainColor()} light={true} />
                )}
                <GlutenFree fill={mainColor()} light={true} />
                {order.oneADay && <OneADay fill={mainColor()} light={true} />}
              </div>
              <form>
                <div>
                  {order.hasVariant && (
                    <>
                      <h3 className="text-18 text-gray-light mt-4">
                        Select your size.
                      </h3>
                      <div className="flex justify-around max-w-sm mx-auto py-4 mb-4">
                        {product.variants[0].availableForSale && (
                          <label className="w-1/2 flex flex-col items-center">
                            <input
                              type="radio"
                              onClick={handleVariantChange}
                              defaultChecked={true}
                              name="size"
                              value={0}
                            />
                            <div className="variantOption">
                              <SmallBottle />
                            </div>
                            <p className="text-gray-light text-14 leading-none text-center opacity-80">
                              <strong className="text-base">{`$${product.variants[0].price} `}</strong>
                              {parseInt(product.variants[0].compareAtPrice) >
                                parseInt(product.variants[0].price) && (
                                <span className="text-red line-through">
                                  ${product.variants[0].compareAtPrice}
                                </span>
                              )}
                              <br />
                              {product.handle === "adreno-ignite" ||
                              product.handle === "chill-out"
                                ? "15 Day Supply"
                                : "1 Month Supply"}
                            </p>
                          </label>
                        )}

                        {product.variants[1].availableForSale && (
                          <label className="w-1/2 flex flex-col items-center">
                            <input
                              type="radio"
                              onClick={handleVariantChange}
                              value={1}
                              name="size"
                            />
                            <div className="variantOption">
                              <LargeBottle />
                            </div>
                            <p className="text-gray-light text-14 leading-none text-center opacity-80">
                              <strong className="text-base">{`$${
                                product.variants[product.variants.length - 1]
                                  .price
                              } `}</strong>
                              {parseInt(
                                product.variants[product.variants.length - 1]
                                  .compareAtPrice
                              ) >
                                parseInt(
                                  product.variants[product.variants.length - 1]
                                    .price
                                ) && (
                                <span className="text-red line-through">
                                  $
                                  {
                                    product.variants[
                                      product.variants.length - 1
                                    ].compareAtPrice
                                  }
                                </span>
                              )}
                              <br />
                              {product.handle === "adreno-ignite" ||
                              product.handle === "chill-out"
                                ? "1 Month Supply"
                                : "2 Month Supply"}
                            </p>
                          </label>
                        )}
                      </div>
                    </>
                  )}
                  {/* <h3 className="text-18 text-gray-light mt-4">
                    Subscribe &amp; save.
                  </h3>
                  <div className="flex justify-around max-w-sm mx-auto py-4 mb-6">
                    <label className="w-1/2 flex flex-col items-center">
                      <input
                        type="radio"
                        onClick={handleRecurringChange}
                        value={false}
                        defaultChecked={true}
                        name="subscribe"
                      />
                      <div className="variantOption">
                        <p className="block text-45 text-gray-lighter">
                          <span className="text-40">x</span>1
                        </p>
                      </div>
                      <p className="text-gray-light text-14 leading-none text-center opacity-80">
                        <strong className="text-base">{`$${
                          product.variants[order.currentVariant].price
                        }`}</strong>
                        <br />
                        One-Time Purchase
                      </p>
                    </label>

                    <label className="w-1/2 flex flex-col items-center">
                      <input
                        type="radio"
                        onClick={handleRecurringChange}
                        value={true}
                        name="subscribe"
                      />
                      <div className="variantOption">
                        <RecurringIcon />
                      </div>
                      <p className="text-gray-light text-14 leading-none text-center opacity-80">
                        <strong className="text-base">{`$${(
                          product.variants[order.currentVariant]
                            .compareAtPrice * 0.85
                        ).toFixed(2)} `}</strong>
                        <span className="text-14 text-red line-through">
                          $
                          {
                            product.variants[order.currentVariant]
                              .compareAtPrice
                          }
                        </span>
                        <br />
                        Subscribe &amp; Save 15%
                      </p>
                    </label>
                  </div> */}
                </div>

                {order.recurring && (
                  <div>
                    <h3 className="text-18 text-gray-light mt-4">
                      Deliver every:
                    </h3>
                    <div className="flex justify-around max-w-sm mx-auto py-4 mb-6">
                      <label className="w-1/2 flex flex-col items-center">
                        <input
                          type="radio"
                          onClick={setRecurringSchedule}
                          value={15}
                          name="schedule"
                        />
                        <div className="variantOption">
                          <p className="block text-14 text-gray-lighter text-center">
                            <span className="text-40">15</span>
                            <br />
                            Days
                          </p>
                        </div>
                      </label>

                      <label className="w-1/2 flex flex-col items-center">
                        <input
                          type="radio"
                          onClick={setRecurringSchedule}
                          value={30}
                          defaultChecked={true}
                          name="schedule"
                        />
                        <div className="variantOption">
                          <p className="block text-14 text-gray-lighter text-center">
                            <span className="text-40">1</span>
                            <br />
                            Month
                          </p>
                        </div>
                      </label>
                    </div>
                    <div className="flex justify-around max-w-sm mx-auto pb-4 mb-6">
                      <label className="w-1/2 flex flex-col items-center">
                        <input
                          type="radio"
                          onClick={setRecurringSchedule}
                          value={60}
                          name="schedule"
                        />
                        <div className="variantOption">
                          <p className="block text-14 text-gray-lighter text-center">
                            <span className="text-40">2</span>
                            <br />
                            Months
                          </p>
                        </div>
                      </label>

                      <label className="w-1/2 flex flex-col items-center">
                        <input
                          type="radio"
                          onClick={setRecurringSchedule}
                          value={90}
                          name="schedule"
                        />
                        <div className="variantOption">
                          <p className="block text-14 text-gray-lighter text-center">
                            <span className="text-40">3</span>
                            <br />
                            Months
                          </p>
                        </div>
                      </label>
                    </div>
                  </div>
                )}

                <CheckoutButtons
                  subscription={order.recurring}
                  context={context}
                  inStock={order.inStock}
                  quantity={order.quantity}
                  productVariant={productVariant}
                  checkoutLink={checkout.webUrl}
                  product={product.title}
                />
              </form>
              <p className="mt-6 text-gray-light md:text-center">
                This medicine may not be right for you.
                <br />
                <button
                  className="text-gold-dark"
                  role="link"
                  onClick={() => {
                    navigate("#warnings");
                  }}
                  onKeyDown={() => {
                    navigate("#warnings");
                  }}
                >
                  <strong>Read the warnings</strong>
                </button>{" "}
                before purchase.
              </p>
            </div>
            {product.handle === "you-beauty" && (
              <div className="md:ml-4 mt-8">
                <iframe
                  className="w-full"
                  height="315"
                  src="https://www.youtube.com/embed/Z-EBzlK_81c?controls=0"
                  title="YouTube video player"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                ></iframe>
              </div>
            )}
          </div>
          <div className="md:flex md:items-center">
            <div className="flex flex-col text-center mx-auto items-center mt-12">
              <FreeShipping />
              <p className="text-gray-light text-14 opacity-80">
                <strong className="text-base">Free Delivery</strong>
                <br />
                On orders over $65
              </p>
            </div>
            <button
              onClick={showModal}
              className="flex flex-col text-center mx-auto items-center mt-8 md:mt-12"
            >
              <MoneyBack />
              <p className="text-gray-light text-14 opacity-80">
                <strong className="text-base">Money Back Guarantee</strong>
                <br />
                Click for details
              </p>
            </button>
          </div>
          <div className="p-8 md:py-10">
            <div
              id="warnings"
              className="border-gray-lighter border-t pt-4 md:pt-10"
            >
              {parse(product.descriptionHtml)}
            </div>
          </div>
        </div>
        <div className="max-w-screen-lg p-8 md:p-10 mx-auto bg-white border border-gray-border md:mt-8">
          <h2 className="text-30 md:text-35 mb-4">Customer Reviews</h2>
          <ProductReviews reviewData={reviews} />
        </div>
      </div>
    </>
  );
};

export default ProductTemplate;

export const query = graphql`
  query ($id: String!, $title: String!) {
    shopifyProduct(handle: { eq: $id }) {
      handle
      id
      title
      productType
      description
      descriptionHtml
      shopifyId
      options {
        id
        name
        values
      }
      variants {
        id
        title
        price
        compareAtPrice
        availableForSale
        shopifyId
        selectedOptions {
          name
          value
        }
      }
      images {
        originalSrc
        id
        localFile {
          childImageSharp {
            gatsbyImageData(
              width: 600
              height: 600
              transformOptions: { fit: CONTAIN }
              backgroundColor: "transparent"
              placeholder: BLURRED
            )
          }
        }
      }
    }
    yotpoProduct(products: { elemMatch: { name: { eq: $title } } }) {
      bottomline {
        averageScore
        totalReview
      }
      productId
      reviews {
        id
        createdAt(formatString: "Do MMM YYYY")
        content
        score
        title
        verifiedBuyer
        user {
          displayName
        }
      }
    }
  }
`;
